export default __webpack_public_path__ + "static/media/Arshiraj.3faafaed.png";